module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "dribl.30cbe697.gif";